// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"257":"8498ba0b","365":"77d16cec","618":"9b8af229"}[chunkId] + ".chunk.js";
};